import React from 'react';
import './styles.css';
import { COMMENT_CLOSED } from '@BUP/constants';
import {
  PageLayout,
  MessagesList
} from '@BUP/components';
import {
  Breadcrumb,
} from 'antd';
import { useInboxMessages } from '@BUP/hooks';
import { FolderOutlined } from '@ant-design/icons';

const BupArchivedPage = () => {
  const { isLoading, messages, error, setMessageState } = useInboxMessages();
  const closedMessages = messages.filter(message => message.state === COMMENT_CLOSED);

  return (
    <PageLayout>
      <div className="archived-page-container">
        <Breadcrumb separator=">" className="modebup-breadcrumb">
          <Breadcrumb.Item>MODO BUP!</Breadcrumb.Item>
          <Breadcrumb.Item>CASOS ARCHIVADOS</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <MessagesList
        title="casos archivados"
        titleDark={true}
        titleIcon={<FolderOutlined />}
        messages={closedMessages}
        isLoading={isLoading}
        error={error}
        handleSetMessageState={setMessageState}
      />
    </PageLayout>
  )
}

export default BupArchivedPage;